import React from 'react';
import { useForm } from 'react-hook-form';
import { css } from '@emotion/css';
import { get } from 'lodash';

const generalStyle = css`
  display: flex;
  flex-direction: column;
`;

const labelStyle = css`
  margin-left: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.3125rem;
`;
const radioStyle = css`
  accent-color: #7b1a27;
  width: 1.5rem;
  height: 1.5rem;
  vertical-align: middle;
  cursor: pointer;
`;

const submitButtonStyle = css`
  width: 14.625rem;
  height: 3rem;
  border-radius: 6.25rem;
  background: #7b1a27;
  color: #fff;
  border: none;
`;
const footerSectionStyle = css`
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
`;

const radioRowStyle = css`
  margin-bottom: 0.5rem;
`;

const fieldRequiredStyle = css`
  font-size: 0.7rem;
  line-height: 1rem;
  color: #7b1a27;
`;

const SelectItemFrequency = ({ frequencyOptions, itemFrequency, submitHandler }) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isDirty, isValid },
  } = useForm({
    defaultValues: {
      FrequencyOption: itemFrequency,
    },
  });

  const onSubmit = (data) => {
    submitHandler(get(data, 'FrequencyOption'));
  };

  const optionList = frequencyOptions.map((option, idx) => (
    <div className={radioRowStyle} key={`freq_${idx}`}>
      <input
        tabIndex={0}
        id={`radio-${idx}`}
        aria-roledescription="radio button"
        aria-label={`Every ${option.displayFrequency}`}
        className={radioStyle}
        type="radio"
        value={option.displayFrequency}
        checked={new RegExp(`^${option.displayFrequency}$`, 'i').test(watch('FrequencyOption'))}
        {...register(`FrequencyOption`)}
      />
      <label htmlFor={`radio-${idx}`} className={labelStyle}>
        Every {option.displayFrequency}
      </label>
    </div>
  ));

  return (
    <form className={`item-list-container ${generalStyle}`} onSubmit={handleSubmit(onSubmit)}>
      <div className="item-list-container" role="radiogroup">
        {optionList}
        {errors.FrequencyOption && <p className={fieldRequiredStyle}>You must select an option</p>}
      </div>
      <div className={footerSectionStyle}>
        <input className={submitButtonStyle} type="submit" value="Confirm" data-testid="frequency-confirm-button" />
      </div>
    </form>
  );
};

export default SelectItemFrequency;
